import type { GtmBrainDoc } from "../api/GtmApi";

export type KeywordListItem = {
  key: string;
  index: number;
  doc: GtmBrainDoc;
  phrase: string;
};

/** Stable key — keep in sync with brainToFlow docLeaves ids. */
export function keywordKey(doc: GtmBrainDoc, keywordIndex: number): string {
  return doc.id || `doc-keyword-${keywordIndex}`;
}

export function listKeywords(docs: GtmBrainDoc[]): KeywordListItem[] {
  const only = docs
    .map((doc, index) => ({ doc, index }))
    .filter(({ doc }) => doc.docType === "keyword");
  return only.map(({ doc, index }, keywordIndex) => {
    const phrase = (doc.phrase || doc.name || "").trim() || `Keyword ${keywordIndex + 1}`;
    return {
      key: keywordKey(doc, keywordIndex),
      index,
      doc,
      phrase,
    };
  });
}
